export default {
  m: {
    1: {
      2: 1000,
      4: 1400,
      9: 1800,
      14: 2200,
      19: 2400,
      31: 2200,
      51: 2000,
    },
    2: {
      2: 1200,
      4: 1500,
      9: 2000,
      14: 2600,
      19: 2700,
      31: 2500,
      51: 2300,
    },
    3: {
      2: 1200,
      4: 1800,
      9: 2300,
      14: 3000,
      19: 3000,
      31: 2900,
      51: 2600,
    },
  },
  f: {
    1: {
      2: 1000,
      4: 1200,
      9: 1600,
      14: 1800,
      19: 2000,
      31: 1800,
      51: 1600,
    },
    2: {
      2: 1200,
      4: 1500,
      9: 1800,
      14: 2000,
      19: 2100,
      31: 2000,
      51: 1800,
    },
    3: {
      2: 1200,
      4: 1600,
      9: 2000,
      14: 2400,
      19: 2400,
      31: 2200,
      51: 2100,
    },
  },
};